import React from 'react';
import InputStyle from './style';

export default function InputMonth({ onChange, disabled, value }) {
  let months = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ];

  return (
    <InputStyle>
      <label>Mês</label>
      <select name="month" onChange={onChange} disabled={disabled} value={value}>
        <option value="Nenhum mês selecionado">Selecione o mês</option>
        {months.map((month, index) => {
          return (
            <option key={index + 1} value={month}>
              {month}
            </option>
          );
        })}
      </select>
    </InputStyle>
  );
}
